import styled from "styled-components";
import Heading from "./Heading";
import Button from "./ButtonBackError";
import { CssBaseline } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../auth/useAuthContext";
import i18next from "i18next";
import toast from "react-hot-toast";
import { Box as BoxMui } from "@mui/material";

const StyledErrorFallback = styled.main`
  height: 100vh;
  background-color: var(--color-grey-50);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4.8rem;
`;

const Box = styled.div`
  /* Box */
  background-color: var(--color-grey-0);
  border: 1px solid var(--color-grey-100);
  border-radius: var(--border-radius-md);

  padding: 4.8rem;
  flex: 0 1 96rem;
  text-align: center;

  & h1 {
    margin-bottom: 1.6rem;
  }

  & p {
    font-family: "Sono";
    margin-bottom: 3.2rem;
    color: var(--color-grey-500);
  }
`;

export default function ErrorFallback({ error, resetErrorBoundary }) {
  let lng = i18next.language;
  const { logout } = useAuthContext()
  const handleLogout = async () => {
    try {
      await logout()
      toast.success(lng === 'ar' ? 'تم تسجيل الخروج بنجاح' : 'You have successfully logged out.');
      localStorage.removeItem('user')
      localStorage.removeItem('accessToken')
      window.location.replace("/login")
      // navigate('/login', { replace: true });

    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  }
  return (
    <>
      <CssBaseline />
      <StyledErrorFallback>
        <Box>
          <Heading as="h1">{lng === 'en' ? 'Something went wrong ' : 'حدث خطأ غير متوقع'}🧐</Heading>
          <p>{error.message}</p>
          <BoxMui sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button size="large" onClick={resetErrorBoundary}>
              {lng === 'en' ? `Try again` : 'حاول مرة أخرى'}
            </Button>
            <Button size="large" onClick={handleLogout}>
              {lng === 'ar' ? 'تسجيل الخروج' : 'Log Out'}
            </Button>
          </BoxMui>
          {/* <Button size="large" onClick={handleLogout}>
            {lng === 'ar' ? 'تسجيل الخروج' : 'Log Out'}
          </Button> */}
          {/* <Typography
            sx={{
              textDecoration: "none",
              fontSize: 14,
              textTransform: 'capitalize',
              fontWeight: 'bold',
              color: theme => theme.palette.nav.link,
              transition: '0.5s',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              gap: '8px',
              '&:hover': {
                color: theme => theme.palette.primary.main,
                textDecoration: 'underline',
                '& svg path:not(.no-svg-color path)': {
                  fill: theme => theme.palette.primary.main,
                }
              },
              '& svg path:not(.no-svg-color path)': {
                fill: theme => theme.palette.nav.link,
              },
              '& svg': {
                width: '20px',
                height: '20px'
              }
            }}
            // onClick={handleLogout}
            className="link">
            {lng === 'ar' ? 'تسجيل الخروج' : 'Log Out'}
          </Typography> */}
        </Box>
      </StyledErrorFallback>
    </>
  );
}

// export default ErrorFallback;
